import { gsap } from 'gsap';
import { CustomEase } from 'gsap/CustomEase';

// Webflow's named CSS curves are not the similarly named GSAP power curves.
gsap.registerPlugin(CustomEase);
export const easing = {
  cubicOut: 'power2.out',
  cssEase: CustomEase.create('arcnova-ease', '0.25,0.1,0.25,1'),
  cssEaseOut: CustomEase.create('arcnova-ease-out', '0,0,0.58,1'),
  cssEaseInOut: CustomEase.create('arcnova-ease-in-out', '0.42,0,0.58,1'),
} as const;

export function reducedMotion(): boolean {
  return (
    typeof window !== 'undefined' && window.matchMedia('(prefers-reduced-motion: reduce)').matches
  );
}
